import axios from 'axios';
import { API } from '../../../context/AuthContext';

const requestConfig = { withCredentials: true };

export const restaurantApi = {
  getRestaurants: (signal) =>
    axios.get(`${API}/restaurants/active`, { ...requestConfig, signal }),

  getMenu: (restaurantId, signal) =>
    axios.get(`${API}/restaurants/${restaurantId}/menu`, { ...requestConfig, signal }),

  getOrders: (signal) =>
    axios.get(`${API}/food/orders/my`, { ...requestConfig, signal }),

  getOrder: (orderId, signal) =>
    axios.get(`${API}/food/orders/${orderId}`, { ...requestConfig, signal }),

  createOrder: (payload) =>
    axios.post(`${API}/food/orders`, payload, requestConfig),

  cancelOrder: (orderId) =>
    axios.post(`${API}/food/orders/${orderId}/cancel`, {}, requestConfig)
};

export function getRestaurantApiError(error, fallback) {
  if (!error?.response) {
    return 'No pudimos conectar con PROVI. Revisa tu conexión e intenta nuevamente.';
  }
  return error.response?.data?.detail || fallback;
}
